/**
 * vatCheckoutStore — SW-8538
 *
 * Holds two independent slices:
 *
 *   1. Form state for Step 2 (VAT Information): `vatId`,
 *      `businessAffirmation`. Setters + `resetVatForm`.
 *
 *   2. Modal-open state (Phase B): `isOpen`, `onComplete`, `planContext`,
 *      `origin`. Lets a caller open the VAT modal with a callback that
 *      fires after the customer-update succeeds. Decouples the modal from
 *      the legacy `?upgrade=2` URL pattern; callers can pass their own
 *      continuation (e.g. `subscription.changePlan(...)` from Pricing or
 *      `createSession` from SubscribeButton). `origin` is a click-source
 *      tag (e.g. "poem", "twist", "editor_trial_expired") that flows into
 *      the modal's analytics events under the `ref` field — matches the
 *      "X Subscribe Clicked" / "Subscribe Modal Viewed" convention used
 *      elsewhere in the app.
 *
 * Country + classification do NOT live here — they are derived from the
 * geolocation API and the onboarding-survey metadata via
 * `useVatCheckoutGate()`.
 *
 * See docs/vat-project/SW-8538-PRODUCTION-PLAN.md §7.
 */
import { create } from "zustand";

export const useVatCheckoutStore = create((set) => ({
  // -------- form state --------
  vatId: "",
  businessAffirmation: false,
  setVatId: (val) => set({ vatId: val }),
  setBusinessAffirmation: (val) => set({ businessAffirmation: val }),
  resetVatForm: () => set({ vatId: "", businessAffirmation: false }),

  // -------- modal-open state (Phase B) --------
  isOpen: false,
  onComplete: null,
  planContext: null,
  origin: null,
  openVatModal: ({ onComplete, planContext = null, origin = null }) =>
    set({
      isOpen: true,
      onComplete: onComplete || null,
      planContext,
      origin: origin || null,
    }),
  closeVatModal: () =>
    set({ isOpen: false, onComplete: null, planContext: null, origin: null }),
}));
